import React, { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { Stack, Box } from '@mui/material'
import { GoogleOAuthProvider } from '@react-oauth/google'

export const LayoutFrame: FC = () => {
  const googleClientId = import.meta.env.GOOGLE_CLIENT_ID

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Box>
        <Stack
          component="main"
          sx={{
            width: '100%',
            margin: '0 auto',
            // need for safari browser
            '@supports (-webkit-touch-callout: none)': {
              minHeight: '-webkit-fill-available',
            },
          }}
        >
          <Outlet />
        </Stack>
      </Box>
    </GoogleOAuthProvider>
  )
}
